import React, { Fragment } from 'react'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import Map from '../Map'
import StreetView from '../StreetView'
import Cyclorama from '../Cyclomedia'
import List from '../List'

const ListOrMap = ({ listShow, online }) =>
  listShow && online ? (
    <List />
  ) : (
    <Map height="100%" width="100%" fitBounds={false} />
  )

const DisplayType = ({ streetViewShow, cycloramaShow, listShow, online }) => (
  <Fragment>
    {streetViewShow && online && <StreetView />}
    {cycloramaShow && online && <Cyclorama />}
    <ListOrMap online={online} listShow={listShow} />
  </Fragment>
)

DisplayType.propTypes = {
  streetViewShow: bool.isRequired,
  cycloramaShow: bool.isRequired,
  listShow: bool.isRequired,
  online: bool.isRequired,
}

const mapStateToProps = ({ ui, spi }) => ({
  streetViewShow: ui.streetViewShow,
  cycloramaShow: ui.cycloramaShow,
  listShow: ui.listShow,
  online: spi.online,
})

export default connect(mapStateToProps)(DisplayType)



// WEBPACK FOOTER //
// ./src/components/DisplayType/index.jsx